module.exports = __webpack_public_path__ + "img/Customer.48519573.svg";